import React from "react";
import InviteTeamMember from "components/InviteTeamMember";
import Scrollbar from "react-scrollbars-custom";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import TeamTopic from "components/TeamTopic";
import TeamVideoStatsCard from "components/TeamVideoStatsCard/TeamVideoStatsCard";
import NetThrivingScoreStatsCard from "components/NetThrivingScoreStatsCard/NetThrivingScoreStatsCard";
import CheckInStatsCard from "components/CheckInStatsCard";
import SlideshowStatsCard from "components/SlideshowStatsCard/SlideshowStatsCard";
import MoreButtonMicrosoftTeams from "components/MoreButtonMicrosoftTeams";
import { useGlobalContext } from "store/contexts/globalContext";
import PeerRecognitionStatsCard from "components/PeerRecognitionStatsCard/PeerRecognitionStatsCard";
import Riddles from "components/Riddle/Riddle";

export default function ({ team, closeRightDrawer, open }) {
  const { microsoftConfigureTab } = useGlobalContext();

  const rightSidebar = (
    <div className="timeline-right-inner">
      <div id="sidebar-default-d" className="sidebar-initial">
        {microsoftConfigureTab && <MoreButtonMicrosoftTeams />}
        <InviteTeamMember teamId={team?.id}> 
          <p className="invite-btn text-center"> Invite Members</p>
        </InviteTeamMember>
        <Riddles />
        <TeamTopic team={team} />
        {team?.role_id === 2 || team?.role_id === 3 ? (
          <NetThrivingScoreStatsCard team_id={team?.id} />
        ) : null}
        {team?.role_id === 2 || team?.role_id === 3 ? (
          <PeerRecognitionStatsCard team_id={team?.id} />
        ) : null}
        {team?.role_id === 2 || team?.role_id === 3 ? (
          <TeamVideoStatsCard team_id={team?.id} />
        ) : null}
        {team?.role_id === 2 || team?.role_id === 3 ? (
          <CheckInStatsCard team_id={team?.id} />
        ) : null}
        {team?.role_id === 2 || team?.role_id === 3 ? (
          <SlideshowStatsCard team_id={team?.id} />
        ) : null}
      </div>
    </div>
  );

  return (
    <>
      <div
        id="right-sidebar"
        className="col-xl-3 col-lg-3 right-sidebar RightSidebarDesktop"
      >
        <Scrollbar>{rightSidebar}</Scrollbar>
      </div>
      <div>
        <Drawer
          open={open}
          onClose={closeRightDrawer}
          direction="right"
          size={295}
        >
          <div className="col-xl-3 col-lg-3 right-sidebar mobileRightSidebar">
            {" "}
            <Scrollbar style={{ display: "contents" }}>
              {rightSidebar}
            </Scrollbar>
          </div>
        </Drawer>
      </div>
    </>
  );
}
